import * as actionTypes from "../../../constants";
import { encounterAPI } from "../../../services/encounter";
import { parseServiceErrors } from "../../../services/encounter/serviceErrors";

import type { ErrorDetails } from "../../../models";
import type { EncounterSnapshotEntity } from "../../../models/encounterEntity";

export const snapshotEncounterAction = (encounterId: string) => (dispatch) => {
  dispatch(snapshotEncounterBegin(encounterId));

  return encounterAPI
    .snapshotEncounter(encounterId)
    .then((encounterEntity) => {
      dispatch(snapshotEncounterCompleted(encounterEntity));
    })
    .catch((reason) => {
      const errors = parseServiceErrors(reason, "Cannot Snapshot Encounter");
      dispatch(snapshotEncounterError(errors));
    });
};

const snapshotEncounterBegin = (id: string) => ({
  payload: id,
  type: actionTypes.SNAPSHOT_ENCOUNTER_BEGIN,
});

const snapshotEncounterCompleted = (snapshot: EncounterSnapshotEntity) => ({
  payload: snapshot,
  type: actionTypes.SNAPSHOT_ENCOUNTER_COMPLETED,
});

const snapshotEncounterError = (errors: ErrorDetails[]) => ({
  payload: errors,
  type: actionTypes.SNAPSHOT_ENCOUNTER_ERROR,
});
